export enum CustomGridHeaderSortBlock {
  Root = 'CustomGridHeaderSort',
}

export enum CustomGridHeaderSortElement {
  Asc = 'asc',
  Desc = 'desc',
}
